/**
 * axios setup to use mock service
 */

import axios from "axios";

const axiosServices = axios.create({
  validateStatus: (status) => {
    return true; // I'm always returning true, you may want to do it depending on the status received
  },
});

// interceptor for http
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error(error.response);
    Promise.reject((error.response && error.response.data) || "Wrong Services");
  }
);

export default axiosServices;
